import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
} from 'reactstrap';
import { Select } from 'antd';
import { toast } from 'react-toastify';
import { removeCenterRequest } from '../../services/api/offline-consult';

const { Option } = Select;

const CenterRemovalModal = ({ isOpen, toggle }) => {
  const [centerId, setCenterId] = useState('');
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [loading, setLoading] = useState(false);

  const deonboardReasons = [
    'Tie-up issues',
    'TDS Deduction',
    'Center Permanently closed',
    'Payment Issues',
    'Others',
  ];

  const handleSubmit = async () => {
    // Prevent multiple submissions
    if (loading) {
      return;
    }

    // Validation
    if (!centerId || !centerId.trim()) {
      toast.error('Please enter Center ID');
      return;
    }

    if (!selectedReason) {
      toast.error('Please select a reason for deonboarding');
      return;
    }

    if (selectedReason === 'Others' && (!customReason || !customReason.trim())) {
      toast.error('Please enter a custom reason');
      return;
    }

    const finalReason = selectedReason === 'Others' ? customReason : selectedReason;

    // Handle submission
    setLoading(true);
    try {
      const payload = {
        centerId: centerId.trim(),
        reason: finalReason,
      };
      
      console.log('Center Removal Data:', payload);
      
      // Call the actual API
      const response = await removeCenterRequest(payload);
      
      if (response.message === 'success') {
        toast.success(`Center ${centerId.trim()} removal request submitted successfully`);
        handleClose();
      } else {
        toast.error(response.errorMessage || 'Failed to remove center. Please try again.');
      }
    } catch (error) {
      console.error('Error removing center:', error);
      toast.error(error.errorMessage || 'Failed to remove center. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    // Reset form
    setCenterId('');
    setSelectedReason('');
    setCustomReason('');
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="md">
      <ModalHeader toggle={handleClose}>Remove Center</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="centerId">
            Center ID <span style={{ color: 'red' }}>*</span>
          </Label>
          <Input
            type="text"
            id="centerId"
            placeholder="Enter Center ID"
            value={centerId}
            onChange={(e) => setCenterId(e.target.value)}
            disabled={loading}
          />
        </FormGroup>

        <FormGroup>
          <Label for="reason">
            Reason for Deonboarding <span style={{ color: 'red' }}>*</span>
          </Label>
          <Select
            id="reason"
            placeholder="Select reason"
            value={selectedReason || undefined}
            onChange={(value) => {
              setSelectedReason(value);
              if (value !== 'Others') {
                setCustomReason('');
              }
            }}
            style={{ width: '100%' }}
            disabled={loading}
          >
            {deonboardReasons.map((reason) => (
              <Option key={reason} value={reason}>
                {reason}
              </Option>
            ))}
          </Select>
        </FormGroup>

        {selectedReason === 'Others' && (
          <FormGroup>
            <Label for="customReason">
              Custom Reason <span style={{ color: 'red' }}>*</span>
            </Label>
            <Input
              type="textarea"
              id="customReason"
              placeholder="Enter custom reason"
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              rows={3}
              disabled={loading}
            />
          </FormGroup>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button color="danger" onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" /> Removing...
            </>
          ) : (
            'Remove Center'
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CenterRemovalModal;
